/*
 * Public API Surface of ngx-mat-range-slider
 */

export * from './lib/ngx-mat-range-slider.component';
export * from './lib/ngx-mat-range-slider.module';
